{
  "name": "@prisma/engines-version",
  "version": "7.10.0-4.0edf323efd1d98336f3f0a68684b56f689b900d3",
  "main": "index.js",
  "types": "index.d.ts",
  "license": "Apache-2.0",
  "author": "Tim Suchanek <suchanek@prisma.io>",
  "prisma": {
    "enginesVersion": "0edf323efd1d98336f3f0a68684b56f689b900d3"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/prisma/engines-wrapper.git",
    "directory": "packages/engines-version"
  },
  "devDependencies": {
    "@types/node": "18.19.76",
    "typescript": "4.9.5"
  },
  "files": [
    "index.js",
    "index.d.ts"
  ],
  "scripts": {
    "build": "tsc -d"
  }
}